// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-3da373e3] .van-sticky {
  width: 100%;
}
@media (width >= 40rem) {
[data-v-3da373e3] .van-sticky {
    max-width: 40rem;
    margin-inline: auto;
    padding: 0 1rem;
}
}
@media (width >= 48rem) {
[data-v-3da373e3] .van-sticky {
    max-width: 48rem;
    margin-inline: auto;
    padding: 0 1rem;
}
}
@media (width >= 64rem) {
[data-v-3da373e3] .van-sticky {
    max-width: 64rem;
    margin-inline: auto;
    padding: 0 1rem;
}
}
@media (width >= 80rem) {
[data-v-3da373e3] .van-sticky {
    max-width: 80rem;
    margin-inline: auto;
    padding: 0 1rem;
}
}
@media (width >= 96rem) {
[data-v-3da373e3] .van-sticky {
    max-width: 96rem;
    margin-inline: auto;
    padding: 0 1rem;
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
